export const GET_USER_DEFAULTS="GET_USER_DEFAULTS";
export const GET_ALL_REBATE_PROGRAMS="GET_ALL_REBATE_PROGRAMS";
export const GET_ALL_CLIENT_CODE="GET_ALL_CLIENT_CODE";
export const GET_ALL_PLAN="GET_ALL_PLAN";
export const GET_ALL_GROUP="GET_ALL_GROUP";
export const GET_CHECK_PAYEE="GET_CHECK_PAYEE";
export const UPDATE_USER_DEFALTS="UPDATE_USER_DEFALTS";
export const VALIDATE_CHECK_PAYEE="VALIDATE_CHECK_PAYEE";
export const GET_TAB_CHANGES="GET_TAB_CHANGES";
export const SET_OVERRIDE_508_COMPLIANCE = 'SET_OVERRIDE_508_COMPLIANCE';